import { useLanguage } from "@/i18n";
import { LogoFull } from "@/components/Logo";

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="relative z-10 border-t border-slate-800/60 bg-slate-950/85 backdrop-blur-sm" data-testid="footer">
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-5 py-10 sm:px-8 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-4">
          <LogoFull className="h-14 w-auto" />
        </div>

        <div className="flex flex-col gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500 sm:flex-row sm:items-center sm:gap-6">
          <span className="text-orange-400/80">pronet-uae.com</span>
          <span className="rounded-full border border-amber-400/25 px-2.5 py-1 text-amber-300/80">
            {t.footer.gdpr}
          </span>
          <span>© {year} PRONET · {t.footer.rights}</span>
        </div>
      </div>
    </footer>
  );
}
